var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9372",
    "data-name": "Group 9372",
    transform: "translate(-1402 -348.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_39018",
    "data-name": "Rectangle 39018",
    transform: "translate(1402 348.573)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 13,
    height: 11,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9370",
    "data-name": "Group 9370",
    transform: "translate(1406.467 352.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9369",
    "data-name": "Group 9369",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M21.145,5.772l.8-.712L21.3,3.944l-1.021.335a1.7,1.7,0,0,0-.4-.232L19.66,3H18.373l-.215,1.047a1.95,1.95,0,0,0-.412.232l-1.013-.335L16.09,5.06l.8.712a1.94,1.94,0,0,0,0,.446l-.8.729.644,1.116,1.03-.326a1.972,1.972,0,0,0,.369.215l.24,1.056H19.66l.232-1.047a2.043,2.043,0,0,0,.378-.215l1.021.326.644-1.116-.8-.729A2.034,2.034,0,0,0,21.145,5.772Zm-2.128,1.3A1.073,1.073,0,1,1,20.089,6,1.073,1.073,0,0,1,19.016,7.076Z",
    transform: "translate(-16.09 -3)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.d5127d9c70653e1af1c52b47463540a1.svg";
export { ForwardRef as ReactComponent };